import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { environment } from '@env';
import { CoreLogger, LogLevel } from '@core/platform/core-logger';
import * as Sentry from '@sentry/angular';
import { version } from '@version';
import { isObject } from 'lodash';
import { PiStorageService } from 'pi-storage';

type SentryOptions = Parameters<typeof Sentry.init>[0] & { enabled?: boolean };

CoreLogger.logLevel = LogLevel.TRACE;

PiStorageService.init(environment.storagePrefix);

if (isObject(environment.sentry) && (environment.sentry as SentryOptions).enabled) {
  Sentry.init(environment.sentry as SentryOptions);
}

console.log(`Init App. Version: ${version}. Production: ${environment.production}.`);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  /*.then((moduleRef) => {
    const applicationRef = moduleRef.injector.get(ApplicationRef);
    const componentRef = applicationRef.components[0];
    // allows to run `ng.profiler.timeChangeDetection();`
    enableDebugTools(componentRef);
  })*/
  .catch((err) => console.error(err));
